<template>
  <div class="overall-bg pb-0">
    <b-row>
      <b-col>
        <!-- <BackToMasters :goback="goback"></BackToMasters> -->
        <!-- <Headerlayout :headertext="t('Tally.title')" :contenttext="t('Tally.contents')"> -->
        <Headerlayout :headertext="t('Tally.contents')">
        </Headerlayout>
      </b-col>
    </b-row>
  </div>

  <div class="overall-bg pt-0">
    <b-form @submit.prevent="handleSubmit">
      <div class="form-white-bg">
        <b-row>
          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <CustomDropdown :label="t('Tally.companyName')" name="companyName" id="companyName"
                v-model="formData.companyId" :items="companies" :rules="{ required: true }" :required-icon="true"
                @change="CompanyOnChange" />
            </div>
          </b-col>

          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <CustomDropdown :label="t('Tally.branchName')" name="branchName" id="branchName"
                v-model="formData.branchId" :items="branches" :rules="{ required: true }" :required-icon="true"
                :disabled="true" :showClear="false" />
            </div>
          </b-col>

          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <CustomDropdown :label="t('Tally.type')" name="type" id="type" v-model="formData.typeId"
                :required-icon="true" :rules="{ required: true }" :items="tallyTypes" @change="TallyTypeOnChange" />
            </div>
          </b-col>

          <!-- <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown
                  :label="t('Tally.visit')"
                  name="visit"
                  id="visit"
                  v-model="formData.visit"
                  :options="visits"
                />
              </div>
            </b-col> -->

          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <Datepicker dateformat="dd-mm-yy" :label="t('Tally.fromDate')" v-model="DateObj.fromDate"
                :disabled="false" />

            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="4" sm="6" v-if="formData.typeId != 6 && formData.typeId !== 7">
            <div class="field">
              <Datepicker dateformat="dd-mm-yy" :label="t('Tally.toDate')" v-model="DateObj.toDate" :disabled="false" />
            </div>
          </b-col>
          <b-col lg="9" md="9" sm="6" class="mt-4">
            <div class="d-flex justify-content-end">
              <Bluebutton @savebtn="handleView" class="me-2" :label="t('Tally.view')" :loading="loading"
                icon="pi pi-eye" />
              <Bluebutton @savebtn="handlePosting" :label="t('Tally.posting')" :loading="POSTloading"
                icon="pi pi-upload" />
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col lg="12" md="12">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <!-- {{ tallyItems }} -->
            <!-- {{ selectedItem }} -->
            <Tableview v-if="!loading" v-model:value="tallyItems" :paginator="true" class="p-datatable-gridlines"
              :rows="10" dataKey="VoucherNo" :rowHover="true" filterDisplay="menu" :loading="loading"
              responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
              :serialNumber="false" :selectionMode="true" v-model:selection="selectedItem"
              @update:selection="$.emit('selectedItem', selectedItem)">

            </Tableview>
          </b-col>
        </b-row>
      </div>
    </b-form>
  </div>

  <Toast />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <WarningMessage :visible="warningPopup" :content="warningContent" @ok="closeWarning()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import Bluebutton from "../../../../../components/GeneralButtons/SaveButton.vue";
import Tableview from "../../../pages/Transaction/Tally/TallyTable.vue";
// import Tableview from "../../../../../components/FormComponents/Table.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import WarningMessage from "../../../../../components/FormComponents/WarningMessage.vue";
import { useTallyStore } from "../../../stores/TallyStore";
import type { TallyItem, FormData } from "../../../types/tally";
import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import moment from "moment";
import { useToast } from "primevue/usetoast";


export default defineComponent({
  name: "TallyPosting",
  components: {
    BackToMasters,
    Headerlayout,
    Footer,
    TextField,
    CustomDropdown,
    Datepicker,
    Bluebutton,
    Tableview,
    SkeletonTableLoader,
    CreateSuccessully,
    UpdatedSuccessfully,
    WarningMessage,
  },
  setup() {
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    let EntityId = ref(0);
    let StoreId = ref(route.query.Id);

    const tallyStore = useTallyStore();
    const loading = computed(() => tallyStore.loading);
    const POSTloading = computed(() => tallyStore.POSTloading);
    const selectedItem: any = ref([]);

    const isScrolled = ref(false);
    const label = ref(t("btn.save"));
    const CancelLabel = ref(t("btn.cancel"));

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    watch(
      () => t("btn.cancel"),
      (newValue) => {
        CancelLabel.value = newValue;
      }
    );

    const successpop = ref(false);
    const updatepop = ref(false);
    const warningPopup = ref(false);
    const warningContent = ref("");

    // Get data from store
    const companies = computed(() => tallyStore.companies);
    const branches = computed(() => tallyStore.branches);
    const visits = computed(() => tallyStore.visits);
    const tallyTypes = computed(() => tallyStore.tallyTypes);
    const tallyItems = computed(() => tallyStore.tallyItems);

    const goback = () => router.back();

    const formData = ref<FormData>({
      companyId: 0,
      companyName: "",
      branchId: 0,
      branchName: "",
      typeId: 0,
      visit: "",
      // fromDate: "",
      // toDate: "",
      fromDate: moment().format("DD-MM-YYYY"),
      toDate: moment().format("DD-MM-YYYY"),
    });

    const DateObj = ref({
      fromDate: "",
      toDate: "",
    })

    const CompanyOnChange = () => {
      debugger;
      const selectedCompany = companies.value.find(
        (company) => Number(company.value) === formData.value.companyId
      ) as { name: string; value: string; branchid: number };

      if (selectedCompany) {
        formData.value.branchId = selectedCompany.branchid;
      }
    }

    const TallyTypeOnChange = () => {
      debugger;
      tallyItems.value.splice(0, tallyItems.value.length);
      selectedItem.value.length = 0;
      const SelectedType = tallyTypes.value.find((x) => x.value == formData.value.typeId);
      EntityId.value = SelectedType ? SelectedType.EntityId : 0;
    }

    const headers = computed(() => [
      {
        header: t("Tally.table.sno"),
        field: "sno",
      },
      {
        header: t("Tally.table.companyName"),
        field: "Company_name",
        bodyclass: "boldclass",
        class: formData.value.typeId != 3 ? "d-none" : "mediumwidth",
      },
      {
        header: t("Tally.table.voucherNo"),
        field: "VoucherNo",
      },
      {
        header: t("Tally.table.date"),
        field: "Date",
      },
      {
        header: t("Tally.table.particulars"),
        field: "Particulars",
        bodyclass: "boldclass",
        class: "mediumwidth",
      },
      {
        header: t("Tally.table.debit"),
        field: "Debit",
      },
      {
        header: t("Tally.table.credit"),
        field: "Credit",
      },
      {
        header: t("Tally.table.voucherType"),
        field: "VoucherType",
        class: "smallwidth",
      },
      {
        header: t("Tally.table.narration"),
        field: "Narration",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("Tally.table.refNo"),
        field: "RefNo",
      },
      {
        field: "action",
        header: "",
        fieldDisplay: "false",
        slot: "action",
      },
    ]);

    const globalFilterFields = ref(headers.value.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    };

    const handleSubmit = async () => {
      debugger;
      try {
        // await tallyStore.postTallyData(formData.value);
        successpop.value = true;
      } catch (error) {
        warningContent.value = t("Tally.errors.submit");
        warningPopup.value = true;
      }
    };

    const handleView = async () => {
      debugger;

      try {
        formData.value.fromDate = moment(DateObj.value.fromDate, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );

        formData.value.toDate = moment(DateObj.value.toDate, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );

        await tallyStore.fetchTallyData(formData.value);
      } catch (error) {
        warningContent.value = t("Tally.errors.fetch");
        warningPopup.value = true;
      }
    };

    const handlePosting = async () => {
      debugger;
      try {
        if (selectedItem.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Warning",
            detail: "Kindly select the items to post",
            life: 3000,
          });
          return;
        }
        else {
          // Get the selected company name
          const selectedCompany = companies.value.find(
            (company) => Number(company.value) === formData.value.companyId
          );
          const companyName = selectedCompany ? selectedCompany.name : "";

          const stockInIdMap = new Map<string, number>();
          let voucherNo = 1;
          selectedItem.value = selectedItem.value.map((item) => {
            if (!stockInIdMap.has(item.StockInId)) {
              stockInIdMap.set(item.StockInId, voucherNo);
              voucherNo++;
            }
            item.VoucherNo = stockInIdMap.get(item.StockInId);

            return item;
          });

          // Map the tally items to the required format
          const mappedTallyItems: TallyItem[] = selectedItem.value.map(item => ({
            Id: item.Id || "0",
            sno: item.sno || "0",
            VoucherNo: "",
            HiddenVoucherNo: item.VoucherNo.toString() || "0",
            Date: item.Date || "",
            Particulars: item.Particulars || "",
            Debit: item.Debit || "0",
            Credit: item.Credit || "0",
            tds: item.tds || "0",
            VoucherType: formData.value.typeId.toString() || "0",
            Narration: item.Narration || "",
            RefNo: item.RefNo || "0",
            is_posting: item.is_posting || "0",
            IsPostingCheck: item.IsPostingCheck || "0",
            Company_name: formData.value.typeId == 3 ? item.Company_name : companyName || "",

            voucher_typeid: formData.value.typeId.toString() || "0",
            company_id: formData.value.companyId.toString() || "0",
            branch_id: formData.value.branchId.toString() || "0",
            created_by: usersData.UserId.toString() || "0",
            visit_typeid: item.visit_typeid || "0",
            tally_date: moment(item.Date, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ) || "",
            Parent: item.Parent || "",
            StockInId: item.StockInId || 0,
            HospitalId: usersData.OrganizationId,
            EntityId: EntityId.value || 0,
            StoreId: StoreId.value || 0,
          }));

          // Send the array of mapped tally items in a single request
          await tallyStore.postTallyData(mappedTallyItems);
          successpop.value = true;
        }

      } catch (error) {
        warningContent.value = t("Tally.errors.post");
        warningPopup.value = true;
      }
    };

    // const handlePosting = async () => {
    //   debugger;

    //   try {
    //     // Get the selected company name
    //     const selectedCompany = companies.value.find(
    //       (company) => Number(company.value) === formData.value.companyId
    //     );
    //     const companyName = selectedCompany ? selectedCompany.name : "";

    //     // Map the tally items to the required format
    //     const mappedTallyItems: TallyItem[] = tallyItems.value.map(item => ({
    //       Id: item.Id || "0",
    //       sno: item.sno || "0",
    //       VoucherNo: item.VoucherNo.toString() || "0",
    //       Date: item.Date || "",
    //       Particulars: item.Particulars || "",
    //       Debit: item.Debit || "0",
    //       Credit: item.Credit || "0",
    //       tds: item.tds || "0",
    //       VoucherType: formData.value.typeId.toString() || "0",
    //       Narration: item.Narration || "",
    //       RefNo: item.RefNo || "0",
    //       is_posting: item.is_posting || "0",
    //       IsPostingCheck: item.IsPostingCheck || "0",
    //       // Company_name: companyName || "",
    //       Company_name: formData.value.typeId == 3 ? item.Company_name : companyName || "",

    //       voucher_typeid: formData.value.typeId.toString() || "0",
    //       company_id: formData.value.companyId.toString() || "0",
    //       branch_id: formData.value.branchId.toString() || "0",
    //       created_by: usersData.UserId.toString() || "0",
    //       visit_typeid: item.visit_typeid || "0",
    //       tally_date: moment(item.Date, "DD/MM/YYYY").format(
    //         "YYYY-MM-DD"
    //       ) || "",
    //       Parent: item.Parent || "",
    //       StockInId: item.StockInId || 0,
    //       HospitalId: usersData.OrganizationId,
    //     }));

    //     // Send the array of mapped tally items in a single request
    //     await tallyStore.postTallyData(mappedTallyItems);
    //     successpop.value = true;
    //   } catch (error) {
    //     warningContent.value = t("Tally.errors.post");
    //     warningPopup.value = true;
    //   }
    // };

    const closetrigger = () => {
      successpop.value = false;
      updatepop.value = false;
      router.back();
    };

    const closeWarning = () => {
      warningPopup.value = false;
    };

    onMounted(async () => {
      await Promise.all([
        tallyStore.fetchCompanies(usersData.OrganizationId, usersData.BranchId, usersData.Admin),
        tallyStore.fetchBranches(usersData.OrganizationId),
        tallyStore.fetchTallyTypes(),

        // tallyStore.fetchVisits(),
      ]);
      if (companies.value.length == 1) {
        formData.value.companyId = Number(companies.value[0].value);
        CompanyOnChange();
      }
    });

    return {
      t,
      loading,
      POSTloading,
      isScrolled,
      label,
      CancelLabel,
      formData,
      DateObj,
      tallyItems,
      headers,
      globalFilterFields,
      filters,
      successpop,
      updatepop,
      warningPopup,
      warningContent,
      companies,
      branches,
      tallyTypes,
      visits,
      handleSubmit,
      handleView,
      handlePosting,
      closetrigger,
      closeWarning,
      goback,
      CompanyOnChange,
      TallyTypeOnChange,
      selectedItem
    };
  },
});
</script>

<style lang="scss">
@media only screen and (max-width: 1980px) and (min-width: 1400px) {
  .container-class {
    max-width: 90% !important;
  }
}

.form-white-bg {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
</style>
